import { combineReducers } from 'redux';
import contact from './contact';
import promo from './promo';
import quote from './quote';
import login from './login';
import signup from './signup';
import resetPassword from './resetPassword';
import changePassword from './changePassword';
import subscribe from './subscribe';
import search from './search';
import comment from './comment';
import Dialogs from './DialogsReducer/Dialogs'
import plinkReducer from './PlinkReducers/PlinkReducers';


export default combineReducers({
    subscribe,
    contact,
    promo,
    quote,
    login,
    signup,
    Dialogs,
    resetPassword,
    plinkReducer,
    changePassword,
    search,
    comment,
    
});
